import React from "react"
import PropTypes from "prop-types"
import { Flex, Card, Avatar, Button, Typography } from "antd"
import PhoneIcon from "../../../../../assets/icons/Phone.svg"
import MessageIcon from "../../../../../assets/icons/messages.svg"
import { MessageCircle } from "ui/Icon/DSIcon/MessageCircle"
import styles from "../../index.module.css"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { createConversation } from "store/conversations"
import { oldRoutes } from "router/old-routes"
import { isGuideSelector } from "store/user"

const { Text } = Typography

const GuideInformationCard = React.memo(({ guide }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loggedIn } = useSelector((store) => store.auth)
  const isGuide = useSelector(isGuideSelector)
  if (!guide) return null
  const { avatar, full_name, phone_number, email } = guide
  const clientMessages = () => {
    dispatch(createConversation({ participant_id: guide.user_id })).then((conversation) =>
      navigate(oldRoutes.clientMessagesPath({}, { conversation_id: conversation.id }))
    )
  }

  return (
    <Card className={styles.mainCard} title="Business Information">
      <Flex gap={8} align="self-start" justify="space-between">
        <Flex align="center" gap={16} justify="space-between">
          <Avatar size={100} className="flex-shrink-0" src={avatar} />
          <Flex gap={8} className={styles.guideInfo}>
            <Text strong>{full_name}</Text>
            <Flex gap={8}>
              <img src={PhoneIcon} alt="Phone" />
              <Text>{phone_number}</Text>
            </Flex>
            <Flex gap={8}>
              <img src={MessageIcon} alt="Message" />
              <Text>{email}</Text>
            </Flex>
          </Flex>
        </Flex>
        <Flex align="center" gap={8} justify="space-between">
          <Button
            icon={
              <Flex align="center">
                <MessageCircle />
              </Flex>
            }
            color="primary"
            variant="outlined"
            size="large"
            onClick={clientMessages}
            disabled={!loggedIn || isGuide}
          >
            Send message
          </Button>
        </Flex>
      </Flex>
    </Card>
  )
})

GuideInformationCard.propTypes = {
  guide: PropTypes.shape({
    avatar: PropTypes.string,
    full_name: PropTypes.string,
    phone_number: PropTypes.string,
    email: PropTypes.string
  })
}

GuideInformationCard.displayName = "GuideInformationCard"

export default GuideInformationCard
